import useFdCalculator from '@components/Calculators/fd/hooks/useFdCalculator';
import CalculatorContainer from '@components/Calculators/fd/CalculatorContainer';
import texts from '@components/Calculators/fd/en.json';

const FdCalculator = (defaultValues) => {
    const { states, callbacks } = useFdCalculator(defaultValues);
    return (
        <>
            <CalculatorContainer
                states={states}
                callbacks={callbacks}
                handleOnClick={defaultValues.handleOnClick}
                disclaimer={texts?.Disclaimer}
            />
        </>
    );
};

export default FdCalculator;
